module.exports = __webpack_public_path__ + "static/media/web-domain.b650bc6c.svg";